import {InputType} from "../../component/form/InputType";
import {ReactComponent as IconDelete} from "../../img/icon/delete.svg";
import {createEmptyDiscountEntry, deriveDiscountEntries} from "./discountUtil";

export const DiscountRangeEditor = ({entries, setter}) => {

    const derivedEntries = deriveDiscountEntries(entries);

    const updateEntry = (index, value, field) => {
        const updatedEntries = derivedEntries.map((entry, entryIndex) => entryIndex === index
            ? {...entry, [field]: value}
            : entry
        );
        setter(deriveDiscountEntries(updatedEntries), "entries");
    };

    const addEntry = () => {
        const previousEntries = deriveDiscountEntries(derivedEntries);
        const lastIndex = previousEntries.length - 1;
        const lastEntry = previousEntries[lastIndex];
        const closedLastEntry = {
            ...lastEntry,
            to: lastEntry.to || lastEntry.from
        };

        setter(deriveDiscountEntries([
            ...previousEntries.slice(0, lastIndex),
            closedLastEntry,
            createEmptyDiscountEntry()
        ]), "entries");
    };

    const removeEntry = (index) => {
        if (derivedEntries.length === 1) {
            return;
        }

        const updatedEntries = derivedEntries.filter((entry, entryIndex) => entryIndex !== index);
        const lastIndex = updatedEntries.length - 1;
        updatedEntries[lastIndex] = {
            ...updatedEntries[lastIndex],
            to: null
        };

        setter(deriveDiscountEntries(updatedEntries), "entries");
    };

    return (
        <div className="discount-range-editor">
            <h2>Rabattstaffel</h2>
            {derivedEntries.map((entry, index) => {
                const lastEntry = index === derivedEntries.length - 1;

                return (
                    <div className="discount-range-row" key={index}>
                        <InputType name="from"
                                   concatId={"-" + index}
                                   type="number"
                                   value={entry.from}
                                   label={index === 0 ? "Von" : ""}
                                   readOnly/>
                        {lastEntry &&
                         <InputType name="to"
                                    concatId={"-" + index}
                                    type="text"
                                    value="offen"
                                    label={index === 0 ? "Bis" : ""}
                                    readOnly/>}
                        {!lastEntry &&
                         <InputType name="to"
                                    concatId={"-" + index}
                                    type="number"
                                    min={entry.from}
                                    step="1"
                                    value={entry.to || ""}
                                    label={index === 0 ? "Bis" : ""}
                                    setter={value => updateEntry(index, value, "to")}
                                    required/>}
                        <InputType name="discount"
                                   concatId={"-" + index}
                                   type="number"
                                   min="0"
                                   max="100"
                                   step="0.1"
                                   value={entry.discount}
                                   label={index === 0 ? "Rabatt %" : ""}
                                   setter={value => updateEntry(index, value, "discount")}
                                   required/>
                        <button type="button"
                                className="discount-range-delete no-link-hover"
                                aria-label="Rabattstaffel entfernen"
                                title="Rabattstaffel entfernen"
                                disabled={derivedEntries.length === 1}
                                onClick={() => removeEntry(index)}>
                            <IconDelete/>
                        </button>
                    </div>
                );
            })}
            <button type="button" className="secondary-button discount-range-add" onClick={addEntry}>
                Staffel hinzufügen
            </button>
        </div>
    );
};
